export enum ESubmissionTags {
  'Economy',
  'PGX',
  'VIS',
  'Pega',
  'Gameplay',
  'Other',
}

export type ISubmissionTags = keyof typeof ESubmissionTags;

export enum ESubmissionStatus {
  Pending = 'Pending', // Submission that has not been reviewed
  Declined = 'Declined', // Submission rejected by Admin
  Submitted = 'Submitted', // Submission is active as a Proposal
}

export interface ISubmission {
  _id: string;
  userId: string;
  tags: ISubmissionTags[];
  title: string;
  summary: string;
  problem: string;
  appetite: string;
  solution: string;
  rabbitHoles: string;
  noGos: string;
  voteOptions?: string[];
  status: ESubmissionStatus;
  isArchived?: boolean;
  archiveReason?: string;
}

export const submissionTags: {
  value: ISubmissionTags;
}[] = Object.values(ESubmissionTags)
  .filter((value) => typeof value === 'string')
  .map((value) => ({ value: value as ISubmissionTags }));
